import { render, staticRenderFns } from "./bookingbox.vue?vue&type=template&id=468c08ae&"
import script from "./bookingbox.vue?vue&type=script&lang=js&"
export * from "./bookingbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports